// 新規スレッドとレス返信のデスクトップフォームで共有する補足説明を定義する。
export const DESKTOP_FORM_HELP_TEXT = {
  attachment:
    "投稿する画像や動画を選択します。\n添付可能ファイル：GIF, JPG, PNG, WEBP, WEBM, MP4(最大20MB)",
  threadDuration:
    "スレッドを保持する期間を指定します。入力形式は板の設定に従います。",
  options:
    "画像レスの許可と、本文・画像の検閲設定を変更します。\nR18画像を許可するとR18タグが自動で付きます。",
  authentication:
    "投稿に必要な認証です。\n入力欄に触れると端末上で短い確認処理を自動で行い、チェックボックスも自動で付きます。通常は操作不要です。",
} as const;
